import { Outlet } from 'react-router-dom';
import { PortalProvider } from '@/contexts/PortalContext';
import { getPortalConfig, PortalType } from '@/lib/portalConfig';

interface PortalLayoutProps {
  portal: PortalType;
}

const PortalLayout = ({ portal }: PortalLayoutProps) => {
  const config = getPortalConfig(portal);

  return (
    <PortalProvider config={config}>
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      <Outlet />
    </PortalProvider>
  );
};

export default PortalLayout;
